import { class_type } from "../fable-library.3.7.20/Reflection.js";
import { defaultArg } from "../fable-library.3.7.20/Option.js";
import { toList } from "../fable-library.3.7.20/Seq.js";
import { mapIndexed } from "../fable-library.3.7.20/Array.js";
import { MarkdownRangeModule_zero, MarkdownRange } from "./Range.fs.js";
import { isNullOrWhiteSpace, replace, split } from "../fable-library.3.7.20/String.js";
import { empty, skipWhile, ofSeq } from "../fable-library.3.7.20/List.js";
import { ParsingContext, parseParagraphs } from "./MarkdownParser.fs.js";
import { formatMarkdown } from "./HtmlFormatting.fs.js";
import { FableTextWriter_$ctor } from "./MarkdownUtils.fs.js";
import { disposeSafe } from "../fable-library.3.7.20/Util.js";
import { toString } from "../fable-library.3.7.20/Types.js";
import { formatAsMd } from "./MarkdownFormatting.fs.js";

export class MarkdownDocument {
    constructor(paragraphs, links) {
        this.paragraphs = paragraphs;
        this.links = links;
    }
}

export function MarkdownDocument$reflection() {
    return class_type("Fable.Formatting.Markdown.MarkdownDocument", void 0, MarkdownDocument);
}

export function MarkdownDocument_$ctor_Z1468BDFA(paragraphs, links) {
    return new MarkdownDocument(paragraphs, links);
}

export function MarkdownDocument__get_Paragraphs(x) {
    return x.paragraphs;
}

export function MarkdownDocument__get_DefinedLinks(x) {
    return x.links;
}

export class Markdown {
    constructor() {
    }
}

export function Markdown$reflection() {
    return class_type("Fable.Formatting.Markdown.Markdown", void 0, Markdown);
}

export function Markdown_$ctor() {
    return new Markdown();
}

export function Markdown_Parse_Z33F6198B(text, newline, parseOptions) {
    const newline_1 = defaultArg(newline, "\n");
    const parseOptions_1 = defaultArg(parseOptions, 0) | 0;
    const lines = toList(mapIndexed((i, s) => [s, new MarkdownRange(i + 1, 0, i + 1, s.length)], split(replace(text, "\r\n", "\n"), ["\n", "\r"])));
    const links = new Map([]);
    return MarkdownDocument_$ctor_Z1468BDFA(ofSeq(parseParagraphs(new ParsingContext(links, newline_1, true, MarkdownRangeModule_zero, parseOptions_1), skipWhile((tupledArg) => isNullOrWhiteSpace(tupledArg[0]), lines))), links);
}

export function Markdown_WriteHtml_2ED819BE(doc, writer, newline, substitutions, crefResolver) {
    const newline_1 = defaultArg(newline, "\n");
    const substitutions_1 = defaultArg(substitutions, empty());
    const crefResolver_1 = defaultArg(crefResolver, (_arg) => (void 0));
    formatMarkdown(writer, false, false, MarkdownDocument__get_DefinedLinks(doc), substitutions_1, newline_1, crefResolver_1, MarkdownDocument__get_Paragraphs(doc));
}

export function Markdown_WriteHtml_4F81CA1A(markdownText, writer, newline, substitutions, crefResolver) {
    Markdown_WriteHtml_2ED819BE(Markdown_Parse_Z33F6198B(markdownText, newline), writer, newline, substitutions, crefResolver);
}

export function Markdown_ToHtml_Z6BE9E069(doc, newline, substitutions, crefResolver) {
    const wr = FableTextWriter_$ctor();
    try {
        Markdown_WriteHtml_2ED819BE(doc, wr, newline, substitutions, crefResolver);
        return toString(wr);
    }
    finally {
        disposeSafe(wr);
    }
}

export function Markdown_ToHtml_Z3EA62BCD(markdownText, newline, substitutions, crefResolver) {
    return Markdown_ToHtml_Z6BE9E069(Markdown_Parse_Z33F6198B(markdownText, newline), newline, substitutions, crefResolver);
}

export function Markdown_ToMd_Z6BE9E069(doc, newline, substitutions, crefResolver) {
    const newline_1 = defaultArg(newline, "\n");
    const substitutions_1 = defaultArg(substitutions, empty());
    const crefResolver_1 = defaultArg(crefResolver, (_arg) => (void 0));
    return formatAsMd(MarkdownDocument__get_DefinedLinks(doc), substitutions_1, newline_1, crefResolver_1, MarkdownDocument__get_Paragraphs(doc));
}

